<template>
    <v-card>
        <v-card-title>{{$t("upload_image")}}</v-card-title>
        <v-card-subtitle>{{$t("upload_item_image")}}</v-card-subtitle>
        <v-card-text>
            <v-file-input
                :label="$t('image')"
                filled
                single-line
                dense
                prepend-icon=""
                show-size
                v-model="image"
                accept="image/*"
                prepend-inner-icon="mdi-camera"
                hide-details></v-file-input>

                <v-progress-linear :value="progress" height="25" class="mt-2" v-if="loading" dark>
                    <template v-slot:default="{ value }">
                        <strong>{{ value }}%</strong>
                    </template>
                </v-progress-linear> 
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" :loading="loading" @click="onUpload">
                upload
            </v-btn>
            <v-btn depressed @click="onCancel">
                cancel
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import itemImage from '../../services/item-image/itemImage';

export default {
    props: {
        itemId: [Number, String]
    },
    data() {
        return {
            image: null,
            loading: false,
            progress: 0
        }
    },
    methods: {
        onUpload() {
            var component = this;
            const formData = new FormData();
            formData.append("item_id", this.itemId);
            formData.append("image", this.image);
            
            this.progress = 0;
            this.loading = true;
            this.$emit("uploading-image", true);

            var onUploadProgress = function(progressEvent) {
                component.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            }

            itemImage.upload(formData, onUploadProgress)
            .then(() => {
                this.$emit("uploaded")
            })
            .finally(() => {
                this.progress = 0;
                this.loading = false;
                this.$emit("uploading-image", false);
            })
        },
        onCancel() {
            this.$emit("cancel");
        }
    }
}
</script>

<style>

</style>